<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-积分商城-商品列表
  -->
  <div class="user" v-loading="loading">
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/plus/looprebate/index/add'">添加</el-button>
    </div>
    <div class="product-content point-list">
      <div class="table-wrap">
        <el-table size="small" :data="tableData"  border style="width: 100%">
          <el-table-column prop="product_name" label="商品名称" >
            <template slot-scope="scope">
              <div class="product-info">
              
                <div class="info">
                  <div class="name">{{ scope.row.product[0].product_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="返利比例">
            <template slot-scope="scope">
             <div style=" white-space: pre-line;">
              {{ scope.row.setting }}
             </div>
            </template>
          </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" >关闭</span>
              <span v-if="scope.row.status == 1" >开启</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-auth="'/plus/looprebate/index/edit'" @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button v-auth="'/plus/looprebate/index/delete'" @click="deleteClick(scope.row.loop_rebate_id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>

     <!--编辑-->
     <Edit v-if="open_edit" :open_edit="open_edit" :gradeList="gradeList"  :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
   <!--添加-->
   <Add v-if="open_add" :open_add="open_add" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'add')"></Add>

<!--编辑-->

  
  </div>
</template>
<script>
import LooprebateApi from '@/api/looprebate.js';
import Edit from './edit.vue';
  import Add from './add.vue';
  import {deepClone} from '@/utils/base.js';
export default {
  components: {
      /*编辑组件*/
      Edit,
      Add
    },
  data() {
    return {
      /*表格数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否加载完成*/
      loading: true,
      /*当前编辑的对象*/
      userModel: {},
      /*是否打开选择商品*/
      isproduct: false,
      /*已有的id*/
      exclude_ids: [],
       /*是否打开添加弹窗*/
       open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        gradeList:[]
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
      /*打开添加*/
      addClick() {
        this.open_add = true
      },

      /*打开编辑*/
      editClick(item) {
        this.userModel = (item)
        console.log(" this.userModel", this.userModel)
        this.open_edit = true
      },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },
 /*关闭弹窗*/
 closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog
          if (e.type == 'success') {
            this.getTableList()
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      LooprebateApi.index(Params, true)
        .then(res => {
          self.exclude_ids = res.data.exclude_ids;
          self.tableData = res.data.list.data;
          self.gradeList = res.data.gradeList
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },

    /*关闭商品选择*/
    closeProductFunc(e) {
      this.isproduct = false;
      if (e.type == 'success') {
        this.addClick(e.params.product_id);
      }
    },

    ///*添加商品*/
    // addClick(product_id) {
    //   this.$router.push('/plus/looprebate/index/add?product_id=' + product_id);
    // },

    // /*编辑商品*/
    // editClick(e) {
    //   let self = this;
    //   this.$router.push({
    //     path: '/plus/looprebate/index/edit',
    //     query: {
    //       loop_rebate_id: e
    //     }
    //   });
    // },

    /* 查询*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      self.getTableList();
    },

    /*删除用户*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          LooprebateApi.deleteLooprebate(
            {
              loop_rebate_id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }

  }
};
</script>

<style>
.point-list .el-input-number--mini {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/looprebate/index/index.vue